import { Collapse, Text } from '@chakra-ui/react';
import { FC, Fragment } from 'react';

import { EventSessionsArticleMarkdown } from '@/components/ui/shared/markdowns/EventSessionsArticleMarkdown/EventSessionsArticleMarkdown';

export interface IShowMoreTextProps {
  text: string;
}

export const ShowMore: FC<IShowMoreTextProps> = ({ text }) => {
  return (
    <Fragment>
      <Collapse startingHeight={70} in={true}>
        <Text>
          <EventSessionsArticleMarkdown source={text} />
        </Text>
      </Collapse>
    </Fragment>
  );
};
